"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTrackDimension;

var _useWebChatAPIContext2 = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useTrackDimension() {
  var _useWebChatAPIContext = (0, _useWebChatAPIContext2.default)(),
      trackDimension = _useWebChatAPIContext.trackDimension;

  return trackDimension;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VUcmFja0RpbWVuc2lvbiIsInVzZVdlYkNoYXRBUElDb250ZXh0IiwidHJhY2tEaW1lbnNpb24iXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VUcmFja0RpbWVuc2lvbi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVRyYWNrRGltZW5zaW9uKCk6IChuYW1lOiBzdHJpbmcsIGRhdGE6IGFueSkgPT4gdm9pZCB7XG4gIGNvbnN0IHsgdHJhY2tEaW1lbnNpb24gfSA9IHVzZVdlYkNoYXRBUElDb250ZXh0KCk7XG5cbiAgcmV0dXJuIHRyYWNrRGltZW5zaW9uO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxpQkFBVCxHQUFnRTtFQUM3RSw0QkFBMkIsSUFBQUMsOEJBQUEsR0FBM0I7RUFBQSxJQUFRQyxjQUFSLHlCQUFRQSxjQUFSOztFQUVBLE9BQU9BLGNBQVA7QUFDRCJ9